import { render, staticRenderFns } from "./AddGroupsModal.vue?vue&type=template&id=31072fca&scoped=true&lang=pug&"
import script from "./AddGroupsModal.vue?vue&type=script&lang=js&"
export * from "./AddGroupsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddGroupsModal.vue?vue&type=style&index=0&id=31072fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31072fca",
  null
  
)

export default component.exports